import Repository from '@/libs/axios'

const whatsAppConfigResource = '/admin/settings/whatsapp'

export default {
  getWhatsAppConfigResource() {
    return Repository.get(`${whatsAppConfigResource}`)
  },
  updateWhatsAppConfigResource(payload) {
    return Repository.post(`${whatsAppConfigResource}`, payload)
  },
  sendTestWhatsAppMessage(payload) {
    return Repository.post(`${whatsAppConfigResource}/test-whatsapp`, payload)
  },
}
